import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { CouponInput as CouponInputForm } from '@bingads-webui-cc-react/coupon-input';
import { i18nPropType, restfulServicePropType } from '../shapes';

// this is a separate component so it can be tested via unit test instead of in the demo
const CouponInputUnMemo = ({
  i18n,
  initialCouponCode,
  setLoading,
  setIsValid,
  setCouponCode,
  restfulService,
  ccBaseUrl,
  cid,
  country,
  currencyId,
}) => (
  <CouponInputForm
    i18n={i18n}
    initialCouponCode={initialCouponCode}
    onValidate={useCallback(
      ({
        isValid,
        couponCode: cc,
      }) => {
        setIsValid(isValid);
        setCouponCode(cc);
      },
      [setIsValid, setCouponCode]
    )}
    ccBaseUrl={ccBaseUrl}
    cid={cid}
    countryCode={country}
    currencyId={currencyId}
    setLoading={setLoading}
    restfulService={restfulService}
  />
);

CouponInputUnMemo.displayName = 'SmartCouponInput';
CouponInputUnMemo.propTypes = {
  i18n: i18nPropType.isRequired,
  initialCouponCode: PropTypes.string.isRequired,
  setCouponCode: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  setIsValid: PropTypes.func.isRequired,
  restfulService: restfulServicePropType.isRequired,
  ccBaseUrl: PropTypes.string.isRequired,
  cid: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
  currencyId: PropTypes.number.isRequired,
};

export const CouponInput = memo(CouponInputUnMemo);
